import { OutlinedInput } from "@mui/material";

type Props = {
  errors: any;
  label: string;
  id: string;
  restProps: any;
  type?: string;
  inputProps?: any;
};

const Input = ({ label, errors, id, restProps, inputProps, type }: Props) => {
  return (
    <div className="flex gap-[10px] flex-col">
      <label htmlFor={id}>{label}</label>
      <div>
        <OutlinedInput
          type={type}
          placeholder={label}
          {...inputProps}
          {...restProps}
          className="bg-white rounded-none w-full"
        />
      </div>
      {errors[id]?.message && errors[id]?.message.length > 0 ? (
        <div className="text-red-600 text-sm cursor-default">
          {errors[id]?.message}
        </div>
      ) : (
        errors[id]?.type === "required" && (
          <div className="text-red-600 text-sm cursor-default">
            {globalThis.translate.em.request.form.fields.required.replace(
              ":id",
              label.replace("*", ""),
            )}
          </div>
        )
      )}
    </div>
  );
};

export default Input;
